import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '10.0751 3.2351'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M19.2801 0.620117C19.0201 1.49012 18.4301 2.24009 17.7101 2.84009C16.9901 3.43009 16.0401 3.82013 15.1601 4.01013C14.3101 4.24013 13.4501 4.41015 12.6301 4.65015C11.8001 4.86015 10.9901 5.10011 10.5201 5.49011L10.0801 5.8501L9.61011 5.53015C9.05011 5.15015 8.2701 4.9102 7.4501 4.71021C6.6301 4.48021 5.77011 4.30014 4.93011 4.02014C4.07011 3.76014 3.1901 3.35014 2.4801 2.77014C1.7701 2.19014 1.16012 1.47012 0.870117 0.620117C1.45012 1.28012 2.14013 1.78014 2.88013 2.14014C3.62013 2.52014 4.39011 2.72012 5.21011 2.87012L7.77011 3.32019C8.63011 3.50019 9.56011 3.72017 10.4601 4.30017L9.55011 4.34009C10.4901 3.64009 11.4401 3.46014 12.3101 3.27014C13.2001 3.11014 14.0701 2.96011 14.9401 2.86011C15.7901 2.76011 16.5501 2.60009 17.3001 2.22009C18.0401 1.85009 18.7201 1.31012 19.2801 0.620117Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
